import './style.scss';
import NoPermissionImg from '../../../../../assets/images/no-permission.png';
import arrowIcon from '../../../../../assets/svg/arrow-right-up.svg';
import { useHistory } from 'react-router-dom';
import getFormatMessage, {
  getLanguage,
} from '../../../../../locales/get-format-message';
import { LanguageType } from '../../../../../lib';
import { getConfig } from '../../../../../config';

interface IProps {
  readonly studioId: string;
  readonly warnText?: string;
}
export const GuideCompanyComponent = (props: IProps) => {
  const { warnText } = props;
  const history = useHistory();

  const goToSettingPage = () => {
    history.push(`/studio/${props.studioId}/setting`);
  };

  const links =
    getConfig().documentConfig.consoleHelperLinks[
      getLanguage || LanguageType.zh_CN
    ];
  const companyHelpLink = links.find(
    (item) => item.label === getFormatMessage('how_company_auth')
  );

  if (warnText) {
    return (
      <div className="bi-overview guide-company-page">
        <img className="no-permission-img" src={NoPermissionImg} />
        <div className="guide-title">
          {getFormatMessage('can_not_view_current_page')}
        </div>
        <div className="guide-desc">{warnText}</div>
      </div>
    );
  }

  return (
    <div className="bi-overview guide-company-page">
      <img className="no-permission-img" src={NoPermissionImg} />
      <div className="guide-title">
        {getFormatMessage('can_not_view_current_page')}
      </div>
      <div className="guide-desc">
        {getFormatMessage('not_has_company_auth_desc')}
      </div>
      <div className="guide-link">
        <div className="a-link" onClick={goToSettingPage}>
          {getFormatMessage('go_to_company_auth')}
        </div>
        <img src={arrowIcon} />
        {!!companyHelpLink && (
          <>
            <a
              style={{ marginLeft: 24 }}
              onClick={() => window.open(companyHelpLink.url, '_blank')}
            >
              {getFormatMessage('how_company_auth')}
            </a>
            <img src={arrowIcon} />
          </>
        )}
      </div>
    </div>
  );
};
